import {
  Boxes,
  LayoutDashboard,
  Package,
  Repeat,
  Route,
  ScrollText,
  Settings,
  Tag,
  Users,
} from 'lucide-react';
import type { ComponentType } from 'react';

/**
 * Les 9 entrées de la barre latérale — `02-ecrans.md` §0, dans l'ordre énoncé
 * par la spec, plus « Abonnements » après Opérations (`06` §8). Fichiers,
 * Expéditions et Pennylane n'y figurent plus : les fichiers s'atteignent depuis Paramètres › Martelet, les runs depuis
 * Journal › Runs, et les factures Pennylane depuis Commandes.
 *
 * Le chemin est la seule source de vérité : un écran qui s'enregistre sur
 * exactement ce chemin apparaît immédiatement dans la navigation, actif, sans
 * toucher à ce fichier (voir `README-shell.md`). Tant qu'un chemin n'a pas de
 * route, le clic mène au `notFoundComponent` global (jamais de page blanche,
 * `02` §0).
 */
export interface NavEntry {
  label: string;
  path: string;
  icon: ComponentType<{ className?: string; 'aria-hidden'?: boolean | 'true' | 'false' }>;
  /** Nombre affiché en badge à côté du libellé (uniquement « Commandes », `02` §0). */
  badgeKey?: 'orders-attention';
}

export const NAV_ENTRIES: readonly NavEntry[] = [
  { label: 'Tableau de bord', path: '/', icon: LayoutDashboard },
  { label: 'Commandes', path: '/commandes', icon: Package, badgeKey: 'orders-attention' },
  { label: 'Bundles', path: '/bundles', icon: Boxes },
  { label: 'Transporteurs', path: '/transporteurs', icon: Route },
  { label: 'Opérations', path: '/operations', icon: Tag },
  { label: 'Abonnements', path: '/abonnements', icon: Repeat },
  { label: 'Journal', path: '/journal', icon: ScrollText },
  { label: 'Paramètres', path: '/parametres', icon: Settings },
  { label: 'Utilisateurs', path: '/utilisateurs', icon: Users },
] as const;
